module.exports = __webpack_public_path__ + "media/reskin-images/img--podcasts-24fc8b22.png";